export default __webpack_public_path__ + "static/media/book_1.f0687be5.svg";